// Meta Pixel helper utilities
// Initializes the Facebook Pixel and exposes helpers for tracking events.

const PIXEL_ID = '1320212723322841'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

export function initPixel() {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  // Standard Meta Pixel snippet (transpiled to TS-friendly form)
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod
        ? n.callMethod.apply(n, arguments as any)
        : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq?.('init', PIXEL_ID)
}

export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(params?: {
  value?: number
  currency?: string
  contents?: any[]
  content_name?: string
}) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      currency: 'USD',
      ...params,
    })
  }
}

export const PIXEL_NOSCRIPT_URL = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
